import { HttpInterceptorFn } from '@angular/common/http';

import { buildInfo } from '../../../build-info';

export const i18nCacheBustInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method === 'GET' && /^\/i18n\/[^/?]+\.json(?:\?.*)?$/.test(req.url)) {
    const separator = req.url.includes('?') ? '&' : '?';

    return next(req.clone({ url: `${req.url}${separator}v=${buildInfo.commitHash}` }));
  }

  return next(req);
};
